import React from 'react';

import SvgDefaultSelected from '../svg/icons/default-selected.svg';

const Checkbox = React.forwardRef(({ label, checked, name, onChange }, ref) => (
  <label htmlFor={name} className="checkbox">
    <input
      id={name}
      ref={ref}
      type="checkbox"
      name={name}
      checked={checked}
      aria-checked={checked}
      title={label}
      onChange={(e) => onChange(e.target.checked)}
    />

    <span className="checkbox__placeholder">
      <SvgDefaultSelected />
    </span>

    <span className="text text--italic text--meta checkbox__label">{label}</span>
  </label>
));

export default Checkbox;
